<template lang="pug">
  #actions-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-properties" md-label="Настройки модуля" v-bind:to="{ name: 'Properties', params: { code: $route.params.code}}")
      md-tab(id="tab-entities" md-label="Сущности" v-bind:to="{ name: 'Entities', params: { code: $route.params.code}}")
      md-tab(id="tab-actions" md-label="Действия" v-bind:to="{ name: 'Actions', params: { code: $route.params.code}}")
</template>

<script>
  export default {
      data() {
          return {title: '', activeTab: ''}
      },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
      computed: {
        module() {
            this.title = this.$store.state.module.module.description;
            return this.$store.state.module.module;
        },
      },
      created() {
        this.getModule();
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
      methods: {
        getModule() {
            this.$store.dispatch('module/getModule');
        }
      }
  }
</script>



// WEBPACK FOOTER //
// menu.vue?837862f0